var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',_vm._b({attrs:{"error":_vm.error}},'base-page',_vm.payload,false),[_c('template',{slot:"stack-trace"},[_vm._v(" "+_vm._s(_vm.payload.error.stack)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }